import React from 'react'
import { ReactComponent as MoMoIcon } from '../assets/Booking-icon/momo2.svg'
import { ReactComponent as BankIcon } from '../assets/Booking-icon/banking-svgrepo-com2.svg'
import ViSaIcon from '../assets/Booking-icon/visa.png'
import CashIcon from '../assets/Booking-icon/cash.png'
import AtmIcon from '../assets/Booking-icon/atmCard.png'
import L2PVIIcon from '../assets/icons/PVI.png'
import L2VNIIcon from '../assets/icons/VNI.png'
import L2VBSHIcon from '../assets/icons/BSH.png'
import L2MICIcon from '../assets/icons/MIC.png'
import L2TASCOIcon from '../assets/icons/Tasco.png'
import { ReactComponent as TNDSBikeIcon } from './../assets/icons/TNDSBike.svg'
import { ReactComponent as MotoBikeIcon } from './../assets/icons/MotoBike.svg'
import { ReactComponent as BikeIcon } from './../assets/icons/50ccbike.svg'
import { ReactComponent as ElectricBikeIcon } from './../assets/icons/ElectricBike.svg'
export const IS_ZALO_MINI_APP = window.APP_CONTEXT === 'zalo-mini-app'

export const SCHEDULE_STATUS_3_0 = [
  {
    label: 'Chưa xác nhận',
    value: 0,
    color: '#ADADAD'
  },
  {
    label: 'Đã xác nhận',
    value: 10,
    color: '#FF7B42'
  },
  {
    label: 'Đã hủy',
    value: 20,
    color: '#424242'
  },
  {
    label: 'Thành công',
    value: 30,
    color: '#34AA44'
  }
]
export const SCHEDULE_STATUS = [
  {
    label: 'Tất cả',
    color: '#C87800',
    key: 'ALL'
  },
  {
    label: 'Chưa xác nhận',
    value: 0,
    color: '#C87800',
    key: 'UNCONFIRMED'
  },
  {
    label: 'Đã xác nhận',
    value: 10,
    color: '#0870D9',
    key: 'CONFIRMED'
  },
  {
    label: 'Đã hủy',
    value: 20,
    color: '#D7D7D7',
    key: 'CANCELED'
  },
  {
    label: 'Đã hoàn thành',
    value: 30,
    color: '#34AA44',
    key: 'CLOSED'
  }
]

export const CUSTOMER_RECEIPT_STATUS = {
  NEW: 'New',
  PROCESSING: 'Processing',
  PENDING: 'Pending',
  FAILED: 'Failed',
  SUCCESS: 'Success',
  CANCELED: 'Canceled'
}
export const RATIO_IMG = {
  DEFAULT: {
    value: '16/9'
  },
  PROMOTIONNEW: {
    value: '16/12'
  }
}
export const CUSTOMER_RECEIPT_STATUS_TO_TEXT = {
  NEW: 'Mới',
  PROCESSING: 'Đang xử lý',
  PENDING: 'Chờ xử lý',
  FAILED: 'Thất bại',
  SUCCESS: 'Thành công',
  CANCELED: 'Đã hủy'
}

export const VIHCLE_TYPES_STATE = {
  CAR: 0,
  OTHER_VEHICLES: 10,
  TRAILERS: 20,
  MOTO_BIKE: 30
}

export const VEHICLE_TYPE = {
  CAR: 1,
  OTHER: 10,
  RO_MOOC: 20,
  MOTOBIKE: 30, // Xe máy
  ELECTRIC_MOTORBIKE: 40 // Xe điện
}

export const MOTO_BIKE_TYPE = [
  {
    value: 30,
    type: 'INSURANCE_MOTORCYCLE_OVER_50CC',
    label: 'Xe > 50cc',
    vehicleType: VEHICLE_TYPE.MOTOBIKE,
    icon: <TNDSBikeIcon></TNDSBikeIcon>
  },
  {
    value: 31,
    vehicleType: VEHICLE_TYPE.MOTOBIKE,
    type: 'INSURANCE_MOTORCYCLE_UNDER_50CC',
    label: <>Xe &#8804; 50cc</>,
    icon: <BikeIcon></BikeIcon>
  },
  {
    value: 32,
    vehicleType: VEHICLE_TYPE.ELECTRIC_MOTORBIKE,
    type: 'INSURANCE_MOTORCYCLE_ELECTRIC',
    label: 'Xe máy điện',
    icon: <ElectricBikeIcon></ElectricBikeIcon>
  }
]
export const ORDER_PAYMENT_STATUS = [
  { value: 'New', label: 'Chưa thanh toán', color: '#0dcaf0' },
  { value: 'Processing', label: 'Tính phí thất bại cần xử lý lại', color: '#0d6efd' },
  { value: 'Pending', label: 'Đang trong quá trình xử lý', color: '#ffc107' },
  { value: 'Failed', label: 'Thanh toán thất bại', color: '#ff6500' },
  { value: 'Success', label: 'Đã thanh toán', color: '#44e33e' },
  { value: 'Canceled', label: 'Đã huỷ', color: '#FF1001' }
]
export const PLATE_COLOR = [
  {
    label: 'Trắng',
    value: 1
  },
  {
    label: 'Xanh',
    value: 2
  },
  {
    label: 'Vàng',
    value: 3
  }
  // {
  //   label: 'Đỏ',
  //   value: 4,
  // },
]
export const SCHEDULE_TYPE = [
  { value: 1, label: 'Đăng kiểm xe định kỳ' },
  { value: 2, label: 'Đăng ký dán thẻ EPASS' },
  { value: 3, label: 'Nộp hồ sơ xe mới' },
  { value: 4, label: 'Thay đổi thông tin xe' },
  { value: 7, label: 'Tư vấn bảo dưỡng' },
  { value: 8, label: 'Tư bảo hiểm' },
  { value: 9, label: 'Tư vấn hoán cải' },
  { value: 10, label: 'Mất giấy đăng kiểm' },
  { value: 11, label: 'Cấp lại tem đăng kiểm' },
  { value: 12, label: 'Tư vấn đăng kiểm xe' },
  { value: 13, label: 'Tư vấn xử lý phạt nguội' },
  { value: 14, label: 'Tư vấn bảo hiểm TNDS xe ô tô' },
  { value: 15, label: 'Tra cứu cảnh báo đăng kiểm' },
  { value: 16, label: 'Hỗ trợ xử lý phạt nguội' },
  { value: 17, label: 'Gia hạn định vị' },
  { value: 18, label: 'Gia hạn phù hiệu xe kinh doanh' },
  { value: 19, label: 'Gia hạn giấy tập huấn' },
  { value: 20, label: 'Gia hạn camera hành trình' },
  { value: 21, label: 'Đăng ký dán thẻ VETC' },
  { value: 22, label: 'Gia hạn BH TNDS' },
  { value: 23, label: 'Nộp hồ sơ xe mới (Ngoài giờ HC)' },
  { value: 24, label: 'Đăng kiểm xe (Ngoài giờ HC)' }
]
export const SCHEDULE_TITLE = {
  [SCHEDULE_TYPE.VEHICLE_INSPECTION]: {
    title: 'Đăng kiểm xe định kỳ',
    subTitle: 'Dành cho khách hàng đặt lịch để đăng kiểm các xe đã đăng kiểm trước đây'
  },
  [SCHEDULE_TYPE.NEW_VEHICLE_INSPECTION]: {
    title: 'Đăng kiểm xe mới',
    subTitle: 'Dành cho khách hàng đăng kiểm lần đầu - không mang phương tiện đến trạm đăng kiểm'
  }
}
export const VIHCLE_TYPES = [
  {
    label: 'Xe ô tô con < 9 chỗ',
    value: 1
  },
  {
    label: 'Xe rơ mooc',
    value: 20
  },
  {
    label: 'Xe bán tải, phương tiện khác',
    value: 10
  }
]
export const VEHICLE_SUB_CATEGORY = {
  CAR: 1, //- Ô tô con
  PASSENGER: 11, //- Ô tô khách
  TRUCKER: 12, //- Xe tải
  GROUP: 13, // đoàn oto
  ROMOOCL: 20, //- Romooc, sơmi romooc
  CAR_SPECIALIZED: 14, // xe bán tải
  ORTHER: 10 // phương tiện khác
}
export const PAYMENT_OBJECT = {
  CASH: {
    id: 1,
    value: 'cash',
    label: 'Tiền mặt',
    enablePaymentOnline: 1,
    icon: (
      <div className="d-flex align-items-center justify-content-center">
        <img src={CashIcon} style={{ maxWidth: '83px', width: '100%', height: '100px' }} />
      </div>
    )
  },
  ATM: {
    id: 2,
    value: 'atm',
    label: 'Chuyển khoản ngân hàng',
    enablePaymentOnline: 1,
    icon: <BankIcon className="w-icon " />
  }, // atm/bank
  MOMO: {
    id: 5,
    value: 'momo',
    label: 'Ví điện tử MoMo',
    enablePaymentOnline: 1,
    icon: <MoMoIcon className="w-icon " />
  },
  CREDIT_CARD: {
    id: 4,
    value: 'creditcard', // visa
    label: 'VISA / MASTER / JCB',
    enablePaymentOnline: 1,
    icon: (
      <div className="d-flex align-items-center justify-content-center">
        <img src={ViSaIcon} style={{ maxWidth: '83px', width: '100%', height: '100px' }} />
      </div>
    )
  },
  DOMESTIC_CARD: {
    id: 6,
    value: 'domesticcard',
    label: 'Thẻ thanh toán nội địa (ATM)',
    enablePaymentOnline: 1,
    icon: (
      <div className="d-flex align-items-center justify-content-center">
        <img src={AtmIcon} style={{ maxWidth: '75px', width: '100%', height: '80px', marginBottom: '10px' }} />
      </div>
    )
  },
  MOMO_BUSINESS: {
    id: 7,
    value: 'momobusiness',
    label: 'Thanh toán qua MoMo',
    enablePaymentOnline: 1,
    icon: <MoMoIcon className="w-icon " />
  }
}
export const VEHICLE_COLOR = { 1: 'WHITE', 2: 'BLUE', 3: 'YELLOW', 4: 'RED' }

export const VIHCLE_CATEGORY_OTO = [
  {
    label: 'Xe ô tô 4 chỗ',
    value: 1001,
    seat: 4
  },
  {
    label: 'Xe ô tô 5 chỗ',
    value: 1002,
    seat: 5
  },
  {
    label: 'Xe ô tô 6 chỗ',
    value: 1003,
    seat: 6
  },
  {
    label: 'Xe ô tô 7 chỗ',
    value: 1004,
    seat: 7
  },
  {
    label: 'Xe ô tô 8 chỗ',
    value: 1005,
    seat: 8
  },
  {
    label: 'Xe ô tô 9 chỗ',
    value: 1006,
    seat: 9
  }
]

export const INSURTANCE_LIST_TYPE = [
  {
    value: 6,
    label: 'Bảo hiểm bắt buộc Xe máy'
  },
  {
    value: 7,
    label: 'Bảo hiểm bắt buộc Ô tô'
  },
  {
    value: 8,
    label: 'Bảo hiểm thân vỏ Ô tô'
  }
]

export const VIHCLE_CATEGORY_BUS = [
  {
    label: 'Xe ô tô 10 chỗ',
    value: 1007,
    seat: 10
  },
  {
    label: 'Xe ô tô 11 chỗ',
    value: 1008,
    seat: 11
  },
  {
    label: 'Xe ô tô 12 chỗ',
    value: 1009,
    seat: 12
  },
  {
    label: 'Xe ô tô 13 chỗ',
    value: 1010,
    seat: 13
  },
  {
    label: 'Xe ô tô 14 chỗ',
    value: 1011,
    seat: 14
  },
  {
    label: 'Xe ô tô 15 chỗ',
    value: 1012,
    seat: 15
  },
  {
    label: 'Xe ô tô 16 chỗ',
    value: 1013,
    seat: 16
  },
  {
    label: 'Xe ô tô 17 chỗ',
    value: 1014,
    seat: 17
  },
  {
    label: 'Xe ô tô 18 chỗ',
    value: 1015,
    seat: 18
  },
  {
    label: 'Xe ô tô 19 chỗ',
    value: 1016,
    seat: 19
  },
  {
    label: 'Xe ô tô 20 chỗ',
    value: 1017,
    seat: 20
  },
  {
    label: 'Xe ô tô 21 chỗ',
    value: 1018,
    seat: 21
  },
  {
    label: 'Xe ô tô 22 chỗ',
    value: 1019,
    seat: 22
  },
  {
    label: 'Xe ô tô 23 chỗ',
    value: 1020,
    seat: 23
  },
  {
    label: 'Xe ô tô 24 chỗ',
    value: 1021,
    seat: 24
  },
  {
    label: 'Xe ô tô 25 chỗ',
    value: 1022,
    seat: 25
  },
  {
    label: 'Xe ô tô 29 chỗ',
    value: 1023,
    seat: 29
  },
  {
    label: 'Xe ô tô 45 chỗ',
    value: 1024,
    seat: 45
  },
  {
    label: 'Xe ô tô 52 chỗ',
    value: 1025,
    seat: 52
  }
]

export const VIHCLE_CATEGORY_TRUCK = [
  {
    label: 'Xe tải dưới 1 tấn',
    value: 2002,
    maxWeight: 999,
    minWeight: 0
  },
  {
    label: 'Xe tải dưới 2 tấn',
    value: 2003,
    maxWeight: 1999,
    minWeight: 1000
  },
  {
    label: 'Xe tải dưới 3 tấn',
    value: 2004,
    maxWeight: 2999,
    minWeight: 2000
  },
  {
    label: 'Xe tải dưới 4 tấn',
    value: 2005,
    maxWeight: 3999,
    minWeight: 3000
  },
  {
    label: 'Xe tải dưới 5 tấn',
    value: 2006,
    maxWeight: 4999,
    minWeight: 4000
  },
  {
    label: 'Xe tải dưới 6 tấn',
    value: 2007,
    maxWeight: 5999,
    minWeight: 5000
  },
  {
    label: 'Xe tải dưới 7 tấn',
    value: 2008,
    maxWeight: 6999,
    minWeight: 6000
  },
  {
    label: 'Xe tải dưới 8 tấn',
    value: 2009,
    maxWeight: 7999,
    minWeight: 7000
  },
  {
    label: 'Xe tải dưới 9 tấn',
    value: 2010,
    maxWeight: 8999,
    minWeight: 8000
  },
  {
    label: 'Xe tải dưới 10 tấn',
    value: 2011,
    maxWeight: 9999,
    minWeight: 9000
  },
  {
    label: 'Xe tải dưới 11 tấn',
    value: 2012,
    maxWeight: 10999,
    minWeight: 10000
  },
  {
    label: 'Xe tải dưới 12 tấn',
    value: 2013,
    maxWeight: 11999,
    minWeight: 11000
  },
  {
    label: 'Xe tải dưới 13 tấn',
    value: 2014,
    maxWeight: 12999,
    minWeight: 12000
  },
  {
    label: 'Xe tải dưới 14 tấn',
    value: 2015,
    maxWeight: 13999,
    minWeight: 13000
  },
  {
    label: 'Xe tải dưới 15 tấn',
    value: 2016,
    maxWeight: 14999,
    minWeight: 14000
  },
  {
    label: 'Xe tải dưới 16 tấn',
    value: 2017,
    maxWeight: 15999,
    minWeight: 15000
  },
  {
    label: 'Xe tải dưới 17 tấn',
    value: 2018,
    maxWeight: 16999,
    minWeight: 16000
  },
  {
    label: 'Xe tải dưới 18 tấn',
    value: 2019,
    maxWeight: 17999,
    minWeight: 17000
  },
  {
    label: 'Xe tải dưới 19 tấn',
    value: 2020,
    maxWeight: 18999,
    minWeight: 18000
  },
  {
    label: 'Xe tải dưới 27 tấn',
    value: 2021,
    maxWeight: 26999,
    minWeight: 26000
  },
  {
    label: 'Xe tải dưới 40 tấn',
    value: 2022,
    maxWeight: 39999,
    minWeight: 27000
  },
  {
    label: 'Xe tải trên 40 tấn',
    value: 2023,
    maxWeight: 99999,
    minWeight: 40000
  }
]

export const VIHCLE_CATEGORY_GROUP = [
  {
    label: 'Xe đầu kéo dưới 19 tấn',
    value: 2024,
    maxWeight: 18999,
    minWeight: 0
  },
  {
    label: 'Xe đầu kéo dưới 27 tấn',
    value: 2025,
    maxWeight: 26999,
    minWeight: 19000
  },
  {
    label: 'Xe đầu kéo dưới 40 tấn',
    value: 2026,
    maxWeight: 39999,
    minWeight: 27000
  },
  {
    label: 'Xe đầu kéo trên 40 tấn',
    value: 2027,
    maxWeight: 99999,
    minWeight: 40000
  }
]

export const VIHCLE_CATEGORY_MOOC = [
  {
    label: 'Xe rơ moóc',
    value: 3000,
    maxWeight: 99999,
    minWeight: 0
  }
]

export const VIHCLE_CATEGORY_PICKUP = [
  {
    label: 'Xe bán tải',
    value: 2001,
    maxWeight: 3999,
    minWeight: 0,
    seat: 5
  }
]

export const VIHCLE_CATEGORY_SPECIALIZED = [
  {
    label: 'Xe chuyên dụng',
    value: 4000
  },
  {
    label: 'Xe 4 bánh có động cơ',
    value: 5000
  },
  {
    label: 'Xe cứu thương',
    value: 6000
  }
]

export const VIHCLE_CATEGORY_ORTHER = [
  {
    label: 'Xe ô tô 10 chỗ',
    value: 1007
  },
  {
    label: 'Xe ô tô 11 chỗ',
    value: 1008
  },
  {
    label: 'Xe ô tô 12 chỗ',
    value: 1009
  },
  {
    label: 'Xe ô tô 13 chỗ',
    value: 1010
  },
  {
    label: 'Xe ô tô 14 chỗ',
    value: 1011
  },
  {
    label: 'Xe ô tô 15 chỗ',
    value: 1012
  },
  {
    label: 'Xe ô tô 16 chỗ',
    value: 1013
  },
  {
    label: 'Xe ô tô 17 chỗ',
    value: 1014
  },
  {
    label: 'Xe ô tô 18 chỗ',
    value: 1015
  },
  {
    label: 'Xe ô tô 19 chỗ',
    value: 1016
  },
  {
    label: 'Xe ô tô 20 chỗ',
    value: 1017
  },
  {
    label: 'Xe ô tô 21 chỗ',
    value: 1018
  },
  {
    label: 'Xe ô tô 22 chỗ',
    value: 1019
  },
  {
    label: 'Xe ô tô 23 chỗ',
    value: 1020
  },
  {
    label: 'Xe ô tô 24 chỗ',
    value: 1021
  },
  {
    label: 'Xe ô tô 25 chỗ',
    value: 1022
  },
  {
    label: 'Xe ô tô 29 chỗ',
    value: 1023
  },
  {
    label: 'Xe ô tô 45 chỗ',
    value: 1024
  },
  {
    label: 'Xe ô tô 52 chỗ',
    value: 1025
  },
  {
    label: 'Xe tải dưới 1 tấn',
    value: 2002
  },
  {
    label: 'Xe tải dưới 2 tấn',
    value: 2003
  },
  {
    label: 'Xe tải dưới 3 tấn',
    value: 2004
  },
  {
    label: 'Xe tải dưới 4 tấn',
    value: 2005
  },
  {
    label: 'Xe tải dưới 5 tấn',
    value: 2006
  },
  {
    label: 'Xe tải dưới 6 tấn',
    value: 2007
  },
  {
    label: 'Xe tải dưới 7 tấn',
    value: 2008
  },
  {
    label: 'Xe tải dưới 8 tấn',
    value: 2009
  },
  {
    label: 'Xe tải dưới 9 tấn',
    value: 2010
  },
  {
    label: 'Xe tải dưới 10 tấn',
    value: 2011
  },
  {
    label: 'Xe tải dưới 11 tấn',
    value: 2012
  },
  {
    label: 'Xe tải dưới 12 tấn',
    value: 2013
  },
  {
    label: 'Xe tải dưới 13 tấn',
    value: 2014
  },
  {
    label: 'Xe tải dưới 14 tấn',
    value: 2015
  },
  {
    label: 'Xe tải dưới 15 tấn',
    value: 2016
  },
  {
    label: 'Xe tải dưới 16 tấn',
    value: 2017
  },
  {
    label: 'Xe tải dưới 17 tấn',
    value: 2018
  },
  {
    label: 'Xe tải dưới 18 tấn',
    value: 2019
  },
  {
    label: 'Xe tải dưới 19 tấn',
    value: 2020
  },
  {
    label: 'Xe tải dưới 27 tấn',
    value: 2021
  },
  {
    label: 'Xe tải dưới 40 tấn',
    value: 2022
  },
  {
    label: 'Xe tải trên 40 tấn',
    value: 2023
  },
  {
    label: 'Xe đầu kéo dưới 19 tấn',
    value: 2024
  },
  {
    label: 'Xe đầu kéo dưới 27 tấn',
    value: 2025
  },
  {
    label: 'Xe đầu kéo dưới 40 tấn',
    value: 2026
  },
  {
    label: 'Xe đầu kéo trên 40 tấn',
    value: 2027
  },
  {
    label: 'Xe bán tải',
    value: 2001
  },
  {
    label: 'Xe chuyên dụng',
    value: 4000
  },
  {
    label: 'Xe 4 bánh có động cơ',
    value: 5000
  },
  {
    label: 'Xe cứu thương',
    value: 6000
  }
]

export const VEHICLE_SUB_TYPE = [
  {
    label: 'Xe ô tô con',
    value: 1,
    vehicleType: 1
  },
  {
    label: 'Xe khách',
    value: 11,
    vehicleType: 10
  },
  {
    label: 'Xe tải',
    value: 12,
    vehicleType: 10
  },
  {
    label: 'Ô tô đầu kéo',
    value: 13,
    vehicleType: 10
  },
  {
    label: 'Rơ moóc và sơ mi rơ moóc',
    value: 20,
    vehicleType: 20
  },
  {
    label: 'Phương tiện khác',
    value: 10,
    vehicleType: 10
  },
  {
    label: 'Xe bán tải',
    value: 14,
    vehicleType: 10
  }
]
export const TTDK_INSURANCE_PARTNER = {
  MIC: {
    id: 1,
    label: 'MIC',
    link: 'https://emic.vn/menuak.aspx?p=G,071_TTDK,XEL#bhhd_xelE',
    icon: (
      <div className="d-flex align-items-center justify-content-center">
        <img src={L2MICIcon} style={{ width: '35px', height: '15px' }} />
      </div>
    )
  },
  TASCO: {
    id: 2,
    label: 'TASCO',
    link: 'https://baohiemtasco.vn/',
    icon: (
      <div className="d-flex align-items-center justify-content-center">
        <img src={L2TASCOIcon} style={{ width: '35px', height: '15px' }} />
      </div>
    )
  },
  PVI: {
    id: 3,
    label: 'PVI',
    link: 'https://ttdk.partner.saladin.vn',
    icon: (
      <div className="d-flex align-items-center justify-content-center">
        <img src={L2PVIIcon} style={{ width: '35px', height: '15px' }} />
      </div>
    )
  },
  VNI: {
    id: 4,
    label: 'VNI',
    link: 'https://ttdk.partner.saladin.vn',
    icon: (
      <div className="d-flex align-items-center justify-content-center">
        <img src={L2VNIIcon} style={{ width: '35px', height: '15px' }} />
      </div>
    )
  },
  BSH: {
    id: 5,
    label: 'BSH',
    link: 'https://ttdk.partner.saladin.vn',
    icon: (
      <div className="d-flex align-items-center justify-content-center">
        <img src={L2VBSHIcon} style={{ width: '35px', height: '15px' }} />
      </div>
    )
  }
}

export const VEHICLE_PURPOSE_USING = [
  {
    value: 0,
    label: 'Xe ô tô không kinh doanh vận tải'
  },
  {
    value: 1,
    label: 'Xe ô tô kinh doanh vận tải'
  }
]

export const VEHICLE_TAXI_USING = [
  {
    value: 0,
    label: 'Không'
  },
  {
    value: 1,
    label: 'Có'
  }
]

export const VEHICLE_PRACTIED_USING = [
  {
    value: 0,
    label: 'Không'
  },
  {
    value: 1,
    label: 'Có'
  }
]

export const INSURTANCE_TYPE = {
  INSURANCE_MOTORBIKE_TNDSBB: 6,
  INSURANCE_CAR_TNDSBB: 7,
  INSURANCE_CAR_BHTV: 8
}

export const USAGE_PURPOSE_TYPE = {
  PASSENGER_TRANSPORT: 1, // Chở người
  PICKUP_MINIVAN: 2, // Pickup-Minivan
  CARGO_TRANSPORT: 3, // Chở hàng
  SPECIALIZED_VEHICLE: 4 // Xe chuyên dụng
}

export const INSURTANCE_CAR_TYPES = [
  {
    label: 'Dưới 6 chỗ ngồi',
    value: 1,
    numberOfSeats: [2, 3, 4, 5],
    insurance_type: 'INSURANCE_OTO_NO_BUSINESS_UNDER_6_SEATS',
    usagePurposeType: USAGE_PURPOSE_TYPE.PASSENGER_TRANSPORT,
    vehicleType: 1,
    vehicleSubType: 1
  },
  {
    label: '6-11 chỗ ngồi',
    value: 2,
    numberOfSeats: [6, 7, 8, 9, 10, 11],
    insurance_type: 'INSURANCE_OTO_NO_BUSINESS_6_TO_11_SEATS',
    usagePurposeType: USAGE_PURPOSE_TYPE.PASSENGER_TRANSPORT,
    vehicleType: 1,
    vehicleSubType: 11
  },
  {
    label: 'Xe vừa chở người, vừa chở hàng (Pickup, minivan)',
    value: 14,
    numberOfSeats: [2, 3, 4, 5, 6, 7, 8],
    insurance_type: 'INSURANCE_OTO_NO_BUSINESS_PICKUP_MINIVAN',
    usagePurposeType: USAGE_PURPOSE_TYPE.PICKUP_MINIVAN,
    vehicleType: 1,
    vehicleSubType: 14
  },
  {
    label: 'Xe chở hàng',
    value: 12,
    numberOfSeats: [1, 2, 3],
    insurance_type: 'INSURANCE_XE_TAI',
    usagePurposeType: USAGE_PURPOSE_TYPE.CARGO_TRANSPORT,
    vehicleType: 10,
    vehicleSubType: 12
  },
  {
    label: 'Xe chuyên dụng',
    value: 10,
    numberOfSeats: [2, 3, 4, 5, 6, 7, 8, 9],
    insurance_type: 'INSURANCE_OTO_SPECIAL',
    usagePurposeType: USAGE_PURPOSE_TYPE.SPECIALIZED_VEHICLE,
    vehicleType: 10,
    vehicleSubType: 10
  }
]

export const SPECIAL_TRANSPORT = [
  {
    label: 'Xe cứu thương',
    value: 1
  },
  {
    label: 'Xe chở tiền',
    value: 2
  }
]

export const TYPE_PRODUCT = {
  INSURANCE_OTO_NO_BUSINESS_UNDER_6_SEATS: 'INSURANCE_OTO_NO_BUSINESS_UNDER_6_SEATS', // Bảo hiểm ô tô không kinh doanh vận tải dưới 6 chỗ
  INSURANCE_OTO_NO_BUSINESS_6_TO_11_SEATS: 'INSURANCE_OTO_NO_BUSINESS_6_TO_11_SEATS', // Bảo hiểm ô tô không kinh doanh vận tải từ 6 đến 11 chỗ
  INSURANCE_OTO_NO_BUSINESS_PICKUP_MINIVAN: 'INSURANCE_OTO_NO_BUSINESS_PICKUP_MINIVAN', // Bảo hiểm ô tô không kinh doanh vận tải xe vừa chở người, vừa chở hàng (Pickup, Minivan)
  INSURANCE_XE_TAI: 'INSURANCE_XE_TAI', // Bảo hiểm ô tô không kinh doanh vận tải xe vừa chở người, vừa chở hàng (Pickup, Minivan)
  INSURANCE_OTO_SPECIAL: 'INSURANCE_OTO_SPECIAL', // Bảo hiểm ô tô không kinh doanh vận tải xe vừa chở người, vừa chở hàng (Pickup, Minivan)

  INSURANCE_OTO_BUSINESS_UNDER_6_SEATS: 'INSURANCE_OTO_BUSINESS_UNDER_6_SEATS', // Bảo hiểm ô tô kinh doanh vận tải dưới 6 chỗ
  INSURANCE_OTO_BUSINESS_6_SEATS: 'INSURANCE_OTO_BUSINESS_6_SEATS', // Bảo hiểm ô tô kinh doanh vận tải 6 chỗ
  INSURANCE_OTO_BUSINESS_7_SEATS: 'INSURANCE_OTO_BUSINESS_7_SEATS', // Bảo hiểm ô tô kinh doanh vận tải 7 chỗ
  INSURANCE_OTO_BUSINESS_8_SEATS: 'INSURANCE_OTO_BUSINESS_8_SEATS', // Bảo hiểm ô tô kinh doanh vận tải 8 chỗ
  INSURANCE_OTO_BUSINESS_9_SEATS: 'INSURANCE_OTO_BUSINESS_9_SEATS', // Bảo hiểm ô tô kinh doanh vận tải 9 chỗ
  INSURANCE_OTO_BUSINESS_10_SEATS: 'INSURANCE_OTO_BUSINESS_10_SEATS', // Bảo hiểm ô tô kinh doanh vận tải 10 chỗ
  INSURANCE_OTO_BUSINESS_11_SEATS: 'INSURANCE_OTO_BUSINESS_11_SEATS', // Bảo hiểm ô tô kinh doanh vận tải 11 chỗ
  INSURANCE_OTO_BUSINESS_PICKUP_MINIVAN: 'INSURANCE_OTO_BUSINESS_PICKUP_MINIVAN', // Bảo hiểm ô tô kinh doanh vận tải xe vừa chở người, vừa chở hàng (Pickup, Minivan)
  INSURANCE_XE_TAI_UNDER_3TAN: 'INSURANCE_XE_TAI_UNDER_3TAN', // Dưới 3 tấn
  INSURANCE_XE_TAI_3_TO_8_TAN: 'INSURANCE_XE_TAI_3_TO_8_TAN', // Từ 3 đến 8 tấn
  INSURANCE_XE_TAI_8_TO_15_TAN: 'INSURANCE_XE_TAI_8_TO_15_TAN', // Trên 8 đến 15 tấn
  INSURANCE_XE_TAI_OVER_15_TAN: 'INSURANCE_XE_TAI_OVER_15_TAN' // Trên 15 tấn
}

export const VEHICLE_SUB_CATEGORY_BHOT = {
  OTO_6CHO: 1003, //Ô tô 6 chỗ
  OTO_7CHO: 1004, //Ô tô 7 chỗ
  OTO_8CHO: 1005, //Ô tô 8 chỗ
  OTO_9CHO: 1006, //Ô tô 9 chỗ
  OTO_10CHO: 1007, //Ô tô 10 chỗ
  OTO_11CHO: 1008, //Ô tô 11 chỗ
  XE_BAN_TAI: 2001, //- Xe bán tải (20)
  XE_TAI_DUOI_1TAN: 2002, //- Xe tải dưới 1 tấn (21)
  XE_TAI_DUOI_2TAN: 2003, //- Xe tải 1-1.9 tấn
  XE_TAI_DUOI_3TAN: 2004, //- Xe tải 2-2.9 tấn
  XE_TAI_DUOI_4TAN: 2005, //- Xe tải 3-3.9 tấn
  XE_TAI_DUOI_5TAN: 2006, //- Xe tải 4-4.9 tấn
  XE_TAI_DUOI_6TAN: 2007, //- Xe tải 5-5.9 tấn
  XE_TAI_DUOI_7TAN: 2008, //- Xe tải 6-6.9 tấn
  XE_TAI_DUOI_8TAN: 2009, //- Xe tải 7-7.9 tấn
  XE_TAI_DUOI_9TAN: 2010, //- Xe tải 8-8.9 tấn
  XE_TAI_DUOI_10TAN: 2011, //- Xe tải 9-9.9 tấn
  XE_TAI_DUOI_11TAN: 2012, //- Xe tải 10-10.9 tấn
  XE_TAI_DUOI_12TAN: 2013, //- Xe tải 11-11.9 tấn
  XE_TAI_DUOI_13TAN: 2014, //- Xe tải 12-12.9 tấn
  XE_TAI_DUOI_14TAN: 2015, //- Xe tải 13-13.9 tấn
  XE_TAI_DUOI_15TAN: 2016, //- Xe tải 14-14.9 tấn
  XE_TAI_DUOI_16TAN: 2017, //- Xe tải 16-16.9 tấn
  XE_TAI_DUOI_17TAN: 2018, //- Xe tải 17-17.9 tấn
  XE_TAI_DUOI_18TAN: 2019, //- Xe tải 18-18.9 tấn
  XE_TAI_DUOI_19TAN: 2020, //- Xe tải 19-19.9 tấn
  XE_TAI_DUOI_27TAN: 2021, //- Xe tải 20-26.9 tấn
  XE_TAI_DUOI_40TAN: 2022, //- Xe tải 27-39.9 tấn
  XE_CHUYENDUNG: 4000, //- Xe chuyên dụng (30)
  XE_CUU_THUONG: 6000 //Xe cứu thương
}

export const RENEW_OPTIONS = [
  {
    value: 1,
    label: '1 năm'
  },
  {
    value: 2,
    label: '2 năm'
  },
  {
    value: 3,
    label: '3 năm'
  },
  {
    value: 4,
    label: '4 năm'
  },
  {
    value: 5,
    label: '5 năm'
  },
  {
    value: 6,
    label: '6 năm'
  },
  {
    value: 7,
    label: '7 năm'
  },
  {
    value: 8,
    label: '8 năm'
  },
  {
    value: 9,
    label: '9 năm'
  },
  {
    value: 10,
    label: '10 năm'
  }
]

export const APP_USER_CATEGORY = {
  PERSONAL_ACCOUNT: 1, //tai khoan ca nhan - mac dinh
  COMPANY_ACCOUNT: 2 //tai khoan doanh nghiep
}

export const PROMOTION_TYPE = {
  NOTI_CRIMINAL: 'NOTI_CRIMINAL', // Mã giảm giá cho sản phẩm phạt nguội
  INSURANCE: 'INSURANCE' // Mã giamr giá
}
